import { useMutation } from "react-query";
import { KpcInstance } from "../instance";

// KPC 수동등록 화면에서 필요한 사원·장비 목록을 한 번에 조회한다.
export const useKpcManualScanBaseData = () =>
  useMutation(async () => {
    const [workersResponse, devicesResponse] = await Promise.all([
      KpcInstance.get("/customer/base/workers"),
      KpcInstance.get("/customer/base/devices"),
    ]);

    if (workersResponse.result !== "00" || devicesResponse.result !== "00") {
      throw new Error(
        workersResponse.message ||
          devicesResponse.message ||
          "수동등록 기본 정보를 불러오지 못했습니다.",
      );
    }

    return {
      workers: workersResponse.data || [],
      devices: devicesResponse.data || [],
    };
  });

// KPC 서버가 세션 점소를 기준으로 등록하므로 점소 코드는 payload에 포함하지 않는다.
export const useKpcManualScans = () =>
  useMutation((payload) => KpcInstance.post("/customer/manual-scans", payload));
